export type CallbackMessagePayload = {
  onModalCloseCallback: (decision: 'OK' | 'CANCEL', data?: unknown) => void;
};

export const isCallback = (data: unknown): data is CallbackMessagePayload => {
  return (
    !!data &&
    typeof data === 'object' &&
    !!Object.getOwnPropertyDescriptor(data, 'onModalCloseCallback')
  );
};
